import Vue from 'vue'
import axios from 'axios'
// 上传文件修改axios默认的提交方式Request payload为：可以识别formData的格式
import Qs from 'qs';
import { Message, Loading } from 'element-ui'
import router from '../router/index'
// 响应时间
axios.defaults.timeout = 20 * 1000

Vue.prototype.sources = []
if (location.hostname === 'localhost' || location.hostname == '127.0.0.1') {  //local
    // Vue.prototype.$baseUrl = 'http://dev.kidsrkidschina.com'
    // Vue.prototype.$baseUrl1 = 'http://localhost:9000'
    // Vue.prototype.$baseUrl2 = 'http://localhost:9010'
    Vue.prototype.$baseUrl = 'https://test.kidsrkidschina.com'
    Vue.prototype.$baseUrl1 = 'https://test.kidsrkidschina.com'
    Vue.prototype.$baseUrl2 = 'https://test.kidsrkidschina.com'
    Vue.prototype.$baseUrl3 = 'https://test.kidsrkidschina.com'
} else if (location.hostname === '47.93.230.5') {  //dev
    Vue.prototype.$baseUrl = 'http://dev.kidsrkidschina.com'
    Vue.prototype.$baseUrl1 = 'http://dev.kidsrkidschina.com'
    Vue.prototype.$baseUrl2 = 'http://dev.kidsrkidschina.com'
    Vue.prototype.$baseUrl3 = 'http://dev.kidsrkidschina.com'
} else if (location.hostname === '47.94.143.244' || location.hostname === 'test.kidsrkidschina.com') {  //test
    Vue.prototype.$baseUrl = 'https://test.kidsrkidschina.com'
    Vue.prototype.$baseUrl1 = 'https://test.kidsrkidschina.com'
    Vue.prototype.$baseUrl2 = 'https://test.kidsrkidschina.com'
    Vue.prototype.$baseUrl3 = 'https://test.kidsrkidschina.com'
} else if (location.hostname === 'api.kidsrkidschina.com') {  //prd
    Vue.prototype.$baseUrl = 'https://api.kidsrkidschina.com'
    Vue.prototype.$baseUrl1 = 'https://api.kidsrkidschina.com'
    Vue.prototype.$baseUrl2 = 'https://api.kidsrkidschina.com'
    Vue.prototype.$baseUrl3 = 'https://39.106.43.93:9010'
} else {
    Message.error('系统异常，请联系管理员')
    retrurn;
}

var loadingInstance
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
    config => {
        // 统一封装每次进行请求数据时，执行element-ui的loading组件
        loadingInstance = Loading.service({
            lock: true,
            text: '数据加载中，请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
        // 每次进入路由前清除之前的所有请求
        // config.cancelToken= new axios.CancelToken (function executor(c) {
        //   global.Cancel.push(c);
        // });
        return config
    },
    err => {
        loadingInstance.close()
        Message.error('请求参数错误')
        return Promise.reject(err)
    }
)
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
    res => {
        if (res.data.code === '00') {
            // 如果code码为00，代表成功，loading组件关闭
            loadingInstance.close()
            return res
        } else if (res.data.code == '44') {
            // 如果code码为44，代表会话过期，跳登录页
            loadingInstance.close()
            const message = Message.error(res.data.msg)
            setTimeout(() => {
                message.close()
                router.push({
                    path: '/login'
                })
            }, 1000)
        } else if (res.data.code == '99') {
            if (window.location.href.substr(window.location.href.length - 5) === 'login') {
                loadingInstance.close()
                Message.error(res.data.msg)
                return res;
            }
            loadingInstance.close()
            Message.error(res.data.msg)

        } else if (res.data.code == '60001') {
            loadingInstance.close()
            Message(res.data.msg)
        } else {
            loadingInstance.close()
            Message.error(res.data.msg)
        }
    },
    err => {
        loadingInstance.close()
        Message.error('请求失败，请稍后再试')
        return Promise.reject(err)
    }
)
// 发送请求
export function fetchPost(url, params, port) {
    let token = sessionStorage.getItem('token')
    // 取消上一个页面的请求
    var CancelToken = axios.CancelToken;
    if (port == "port") {
        axios.defaults.baseURL = this.$baseUrl2
    } else {
        axios.defaults.baseURL = this.$baseUrl1
    }
    var token_ = new CancelToken(function executor(c) {
        // cancelToken
        Vue.prototype.sources.push(c)
        // source.push(c)
    })
    return new Promise((resolve, reject) => {
        axios
            .post(url, JSON.stringify(params), {
                headers: {
                    'Content-Type': 'application/json',
                    // 调用每个post接口时，向 header头添加 token
                    'X-Token': token
                }
            })
            .then(
                res => {
                    resolve(res.data)
                },
                err => {
                    reject(err.data)
                }
            )
            .catch(err => {
                reject(err.data)
            })
    }, {
            cancelToken: token_,
        })
}
// 发送请求-上传文件-post表单格式
export function fetchPostUpload(url, params, port) {
    let token = sessionStorage.getItem('token')
    // 取消上一个页面的请求
    var CancelToken = axios.CancelToken;
    if (port == "port") {
        axios.defaults.baseURL = this.$baseUrl2
    } else {
        axios.defaults.baseURL = this.$baseUrl1
    }
    var token_ = new CancelToken(function executor(c) {
        // cancelToken
        Vue.prototype.sources.push(c)
        // source.push(c)
    })
    return new Promise((resolve, reject) => {
        axios
            .post(url, Qs.stringify(params), {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // 调用每个post接口时，向 header头添加 token
                    'X-Token': token
                }
            })
            .then(
                res => {
                    resolve(res.data)
                },
                err => {
                    reject(err.data)
                }
            )
            .catch(err => {
                reject(err.data)
            })
    }, {
            cancelToken: token_,
        })
}
// export function fetchPostJson(url, params) {
//     return new Promise((resolve, reject) => {
//         axios
//             .post(url, params)
//             .then(
//                 res => {
//                     resolve(res.data)
//                 },
//                 err => {
//                     reject(err.data)
//                 }
//             )
//             .catch(err => {
//                 reject(err.data)
//             })
//     })
// }


export function fetchGet(url, params, port) {
    let token = sessionStorage.getItem('token')
    if (port == "port") {
        axios.defaults.baseURL = this.$baseUrl2
    } else {
        axios.defaults.baseURL = this.$baseUrl1
    }
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params,
                headers: {
                    'Content-Type': 'application/json',
                    // 调用每个post接口时，向 header头添加 token
                    'X-Token': token
                }
            })
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err.data)
            })
    })
}



// WEBPACK FOOTER //
// ./src/api/axiosConfig.js